
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//STYLE
import { CollapseAcc } from "./styled";
import React, { useState } from "react";
import { Render } from "../render";

//PROPS
interface Props {
    label: string | React.ReactNode;
    extra?: React.ReactNode;
    isFirst?: boolean;
    isLast?: boolean;
    single?: boolean;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    open: boolean;
    disabled?: boolean;
    trigger: Function;
}

export const Accordion: React.FC<Props> = ({ label, open, trigger, extra, isFirst, isLast, single, children, style, disabled }) => {
     
    return (
        <CollapseAcc style={style} data-isFirst={isFirst} data-isLast={isLast} data-single={single} data-disabled={disabled} >
            <button className="CollapseAcc__header" data-opened={open} onClick={disabled ? ()=>{} : ()=>{trigger()}}>
               <div className="CollapseAcc__header__main">
                    <FontAwesomeIcon icon={faAngleRight} className="CA__header__main__arrow" data-opened={open} style={{display:disabled?'none':undefined}} />
                    {label}
               </div>
               {extra}
            </button>
            
            <Render condition={open} >
                <div className="CollapseAcc__content">
                    {children}
                </div>
            </Render>
            
        </CollapseAcc>
    )
}